<template>
    <div class="block-container">
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>基本信息</span>
                <a class="swb-btn-link" v-if="servcWorkVoucher.servcType == 6" @click="showDevcInspectInfo(servcWorkVoucher.id)">查看检验信息</a>
            </div>
            <div class="fr">
                <a class="swb-btn-link" @click="openWorkVoucherPdfDlg(servcWorkVoucher.id)">打印</a>
            </div>
        </div>
        <div class="form-single">
            <div class="title">工单编号</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.no}}</label>
                <el-tag v-if="servcWorkVoucher.servcType != null" type="success">{{workServcTypeMap[servcWorkVoucher.servcType]}}</el-tag>
                <el-tag v-if="servcWorkVoucher.remoted" type="success">远程解决</el-tag>
            </div>
        </div>
        <div class="form-single">
            <div class="title">交易单号</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.tradeNo || ''}}</label>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.devcPartName != null">
            <div class="title">维修部件</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.devcPartName || ''}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">紧急状态</div>
            <div class="content">
                <label v-if="servcWorkVoucher.emgLevel == 0" class="font-green mr20">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</label>
                <label v-if="servcWorkVoucher.emgLevel == 1" class="font-orange mr20">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</label>
                <label v-if="servcWorkVoucher.emgLevel == 2" class="font-red mr20">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">工单模式</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.grabFlag ? '抢单' : '指派'}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">工单状态</div>
            <div class="content">
                <label class="mr20 font-red" v-if="servcWorkVoucher.closed">已关闭</label>
                <label class="mr20 font-red" v-else-if="servcWorkVoucher.invalid">已作废</label>
                <label class="mr20" v-else>{{servcWorkVoucher.stateText}}</label>
                <el-tag v-if="servcWorkVoucher.evalFlag" type="success">已评价</el-tag>
            </div>
        </div>
        <div class="form-single">
            <div class="title">订单编号</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.orderNo}}</label>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.reqVoucherId != null && servcWorkVoucher.reqVoucherId != -1">
            <div class="title">请求单编号</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.servcReqVoucher.no}}</label>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.reqVoucherId != null && servcWorkVoucher.reqVoucherId != -1">
            <div class="title">请求时间</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.requestTime}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">工单创建时间</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.createTime}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">工单创建人</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.creatorName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">工单截止时间</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.yqFinishTime}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">指派网点</div>
            <div class="content">
                <label class="mr20" v-if="servcWorkVoucher.servicerShopId == null">未指派</label>
                <label class="mr20" v-else>{{servcWorkVoucher.manualShopFlag ? '手工' : '自动'}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">指派工程师</div>
            <div class="content">
                <label class="mr20" v-if="servcWorkVoucher.engineerId == null">未指派</label>
                <label class="mr20" v-else>{{servcWorkVoucher.manualEngFlag ? '手工' : '自动'}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">是否约定期保外</div>
            <div class="content">
                <el-tag v-if="servcWorkVoucher.beyondWrnt" type="danger">交易约定外</el-tag>
                <el-tag type="success" v-else>交易约定内</el-tag>
            </div>
        </div>
        <div class="form-single">
            <div class="title">业务标签</div>
            <div class="content">
                <span v-if="servcWorkVoucher.hasTag" v-for="tagName in servcWorkVoucher.tagNames">
                    <span class="swb-tags swb-tags-success mr5">{{tagName}}</span>
                </span>
                <span class="swb-tags swb-tags-success mr5" v-else>{{servcWorkVoucher.servicerTag}}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">技术审核</div>
            <div class="content">
                <span>{{servcWorkVoucher.techAuditRequired ? "需要" : "不需要"}}</span>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.techAuditRequired">
            <div class="title">技术审核状态</div>
            <div class="content">
                <span v-if="servcWorkVoucher.techApplyState == 0">未申请</span>
                <span v-if="servcWorkVoucher.techApplyState == 1">待审核</span>
                <div v-if="servcWorkVoucher.techApplyState == 2">
                    <span v-if="servcWorkVoucher.techAuditState == 1">审核通过</span>
                    <span v-if="servcWorkVoucher.techAuditState == -1">审核未通过</span>
                </div>
            </div>
        </div>
        <div v-if="servcWorkVoucher.techAuditRequired && servcWorkVoucher.techApplyState != 0">
            <div class="form-single">
                <div class="title">申请时间</div>
                <div class="content">
                    <span>{{servcWorkVoucher.techApplyTime || ''}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">申请完成描述</div>
                <div class="content">
                    <span>{{servcWorkVoucher.techApplyDesc || ''}}</span>
                </div>
            </div>
        </div>
        <div v-if="servcWorkVoucher.techAuditRequired && servcWorkVoucher.techAuditState != 0">
            <div class="form-single">
                <div class="title">技术审核时间</div>
                <div class="content">
                    <span>{{servcWorkVoucher.techAuditTime || ''}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">技术审核人</div>
                <div class="content">
                    <span>{{servcWorkVoucher.techAuditorName || ''}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">技术审核描述</div>
                <div class="content">
                    <span>{{servcWorkVoucher.techAuditDesc || ''}}</span>
                </div>
            </div>
        </div>
        <div class="form-single">
            <div class="title">备注</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.servicerMemo || ''}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">违约状态</div>
            <div class="content">
                <label class="mr20" v-if="servcWorkVoucher.violated">{{servcWorkVoucher.violateState == 0 ? '违约(已处理)' : '违约(未处理)'}}</label>
                <label class="mr20" v-else>未违约</label>
            </div>
        </div>
        <div v-if="servcWorkVoucher.servcType == 2 && servcWorkVoucher.devcSetupInfo != null && servcWorkVoucher.devcSetupInfo.devcSetupItemList != null && servcWorkVoucher.devcSetupInfo.devcSetupItemList.length > 0">
            <div class="content-caption bg-white dashed">
                <div class="fl">
                    <span>安装信息</span>
                </div>
            </div>
            <div class="form-single">
                <el-table :data="servcWorkVoucher.devcSetupInfo.devcSetupItemList" border style="width: 100%">
                    <el-table-column prop="devcXN" label="设备编号" align="left" width="220"></el-table-column>
                    <el-table-column prop="shopDeviceSvcSubNo.vendorUkno" label="商品标识码" align="left" width="220"></el-table-column>
                    <el-table-column prop="shopDeviceSvcSubNo.sellerName" label="卖家名称" align="left" width="220"></el-table-column>
                    <el-table-column prop="extraInfo" label="其他信息" align="left"></el-table-column>
                    <el-table-column prop="asmblFlag" label="含组装商品" width="150" align="center">
                        <template slot-scope="rows">
                            <span>{{rows.row.asmblFlag ? '是' : '否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="asmblDone" label="是否组装完成" width="150" align="center">
                        <template slot-scope="rows">
                            <span v-if="rows.row.asmblFlag">{{rows.row.asmblDone ? '是' : '否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="asmblWhileSetup" label="安装时完成组装" width="150" align="center">
                        <template slot-scope="rows">
                            <span>{{rows.row.asmblWhileSetup ? '是' : '否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="80" label="操作">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" v-if="rows.row.asmblFlag" @click="showAsmblInfo(rows.row.devcId)">组装信息</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>服务信息</span>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.servcOrderItemList != null">
            <el-table :data="servcWorkVoucher.servcOrderItemList" border style="width: 100%">
                <el-table-column prop="title" label="服务名称" width="260" align="left"></el-table-column>
                <el-table-column prop="catName" label="服务分类" width="180" align="left"></el-table-column>
                <el-table-column prop="amount" label="价格(元)" width="180" align="right"></el-table-column>
                <el-table-column prop="" label="操作">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" @click="toChargeItems(servcWorkVoucher.id, rows.row.id)">查看收费项</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.devcVendorSn != null">
            <div class="title">厂商序列号</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.devcVendorSn || '无'}}</label>
            </div>
        </div>
        <div v-if="servcWorkVoucher.deviceSubNoId != null">
            <div class="form-single">
                <div class="title">系统编号</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.tmpNo || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">商品标识码</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.vendorUkno || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">设备名称</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.deviceName || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">设备分类</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.deviceCatName || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">设备品牌</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.deviceBrandName || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">所在部门</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.departName || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">位置编码</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.devcLocCode}}</label>
                </div>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.servcWorkDeviceParts != null && servcWorkVoucher.servcWorkDeviceParts.length > 0">
            <div class="title">部件名称</div>
            <div class="content" v-for="(servcWorkDevicePart, index) in servcWorkVoucher.servcWorkDeviceParts">
                <label class="mr20">{{servcWorkDevicePart.partName}}</label>
            </div>
        </div>

        <div class="content-caption bg-white dashed" v-if="servcWorkVoucher.servcWorkAccItemList != null &&　servcWorkVoucher.servcWorkAccItemList.length>0">
            <div class="fl">
                <span>配件信息</span>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.servcWorkAccItemList != null &&　servcWorkVoucher.servcWorkAccItemList.length>0">
            <el-table :data="servcWorkVoucher.servcWorkAccItemList" border style="width: 100%">
                <el-table-column prop="accName" label="配件名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="quantity" label="个数" width="60" align="right"></el-table-column>
                <el-table-column prop="unit" label="单位" width="60" align="center"></el-table-column>

                <el-table-column prop="shareAccFlag" label="自用" width="80" align="center">
                    <template slot-scope="scope">
                        <span style="color: green;" v-if="scope.row.shareAccFlag">是</span>
                        <span style="color: red;" v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mountFlag" label="拆卸标记" width="80" align="center">
                    <template slot-scope="scope">
                        <span style="color: green;" v-if="scope.row.mountFlag == 1">换上</span>
                        <span style="color: red;" v-else>换下</span>
                    </template>
                </el-table-column>
                <el-table-column prop="vendorSn" label="厂商序列号" width="140" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="replaceFlag" label="更换信息" width="140" align="left" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.mountFlag == 1 && scope.row.replaceFlag && scope.row.replacedVendorSn != null">
                            更换了{{scope.row.replacedVendorSn}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="replaceDesc" label="更换说明" width="160" align="left" show-overflow-tooltip></el-table-column>

                <el-table-column prop="price" label="单价(元)" width="80" align="right"></el-table-column>
                <el-table-column prop="amount" label="价格(元)" width="80" align="right"></el-table-column>
                <el-table-column prop="accClaim.price" label="要求价格下限(元)" width="120" align="right"></el-table-column>
                <el-table-column prop="accClaim.price2" label="要求价格上限(元)" width="120" align="right"></el-table-column>
                <el-table-column prop="metFlag" label="要求是否满足" width="110" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.refAccClaimId != null && scope.row.refAccClaimId != -1 && !scope.row.shareAccFlag">
                            <span style="color: green;" v-if="scope.row.metFlag">满足</span>
                            <span style="color: red;" v-else>不满足</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="content-caption dashed" v-if="servcWorkVoucher.spotImageUrl != null && servcWorkVoucher.spotImageUrl.length > 0">
            <span>现场图片</span>
        </div>
        <div class="file-item viewable image" v-if="servcWorkVoucher.spotImageUrl != null && servcWorkVoucher.spotImageUrl.length > 0">
            <img style="width: 120px;height: 120px;" @click="showImage(servcWorkVoucher.spotImageUrl)" :src="servcWorkVoucher.spotImageUrl"/>
        </div>

        <div class="content-caption bg-white dashed" v-if="servcWorkVoucher.servcWorkRepairImgFileList != null && servcWorkVoucher.servcWorkRepairImgFileList.length > 0">
            <span>{{servcWorkVoucher.servcType == 2 ? '安装' : '问题' }}图片</span>
        </div>
        <div class="file-item viewable image" v-if="servcWorkVoucher.servcWorkRepairImgFileList != null && servcWorkVoucher.servcWorkRepairImgFileList.length > 0">
            <img style="width: 200px;height: 200px;" class="mr10" @click="showImage(servcWorkImgFile.fileBrowseUrl)" :src="servcWorkImgFile.fileBrowseUrl" v-for="servcWorkImgFile in servcWorkVoucher.servcWorkRepairImgFileList"/>
        </div>
        <div class="content-caption bg-white dashed" v-if="servcWorkVoucher.servcWorkImgFileList != null && servcWorkVoucher.servcWorkImgFileList.length > 0">
            <span>完成图片</span>
        </div>
        <div class="file-item viewable image" v-if="servcWorkVoucher.servcWorkImgFileList != null && servcWorkVoucher.servcWorkImgFileList.length > 0">
            <img style="width: 200px;height: 200px;" class="mr10" @click="showImage(servcWorkImgFile.fileBrowseUrl)" :src="servcWorkImgFile.fileBrowseUrl" v-for="servcWorkImgFile in servcWorkVoucher.servcWorkImgFileList"/>
        </div>
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>费用信息</span>
            </div>
            <div class="fr">
                <span>总费用(元)：{{servcWorkVoucher.amount}}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">是否免费</div>
            <div class="content">
                <label class="mr20">
                    <span class="swb-tags swb-tags-success" v-if="servcWorkVoucher.freeFlag">免费</span>
                    <span class="swb-tags swb-tags-danger" v-else>收费</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">上门费(元)</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.toDoorFee == null ? '无' : servcWorkVoucher.toDoorFee}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">服务费(元)</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.generallFee == null ? '无' : servcWorkVoucher.generallFee}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">配件费(元)</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.accFee == null ? '无' : servcWorkVoucher.accFee}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">绩效标记</div>
            <div class="content">
                <label class="mr20">{{performFlagEnumMap[servcWorkVoucher.performFlag]}}</label>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.performFlag == 2 && servcWorkVoucher.finished">
            <div class="title">计件金额</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.jbAmount}}</label>
            </div>
        </div>
        <!--去掉虚拟供应商-->
        <div v-if="servcWorkVoucher.srcVendorId != null && servcWorkVoucher.srcVendorId != -1">
            <div class="content-caption bg-white dashed">
                <div class="fl">
                    <span>供方信息</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">供应商名称</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.srcVendorName}}</label>
                </div>
            </div>
        </div>
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>请求信息</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">服务请求方</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.buyerName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">请求机构</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.buyerShopName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">请求机构编号</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.buyerShopNo || ''}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">请求人</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.requesterStaffName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">请求人电话</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.requesterContactTel || ""}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">请求地址</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.buyerShopAddr}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">请求机构联系电话</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.buyerShopContactTel}}</label>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.reqVoucherId != null && servcWorkVoucher.reqVoucherId != -1">
            <div class="title">请求描述</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.requestDesc || '无'}}</label>
            </div>
        </div>
        <div class="form-single" v-if="servcWorkVoucher.troubleDesc != null">
            <div class="title" v-if="servcWorkVoucher.servcType == 2">安装说明</div>
            <div class="title" v-else-if="servcWorkVoucher.servcType == 3 || servcWorkVoucher.servcType == 5">描述</div>
            <div class="title" v-else>情况描述</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.troubleDesc || '无'}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">预约上门时间</div>
            <div class="content">
                <label class="mr20">
                    {{servcWorkVoucher.planTime || '无'}}
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">要求响应时长(分钟)</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.yqRspTimeMi || '无'}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">要求到达时长(分钟)</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.yqArriveTimeMi || '无'}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">要求完成时长(分钟)</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.yqRepairedTimeMi || '无'}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">要求回询时限(分钟)</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.reqTelCallTimeMi || '无'}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">计划出发时间</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.planStartOffTime || '无'}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">预计完成时间</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.estiFinishTime || '无'}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">实际响应时长(分钟)</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.rspTimeMi == null ? '无' : servcWorkVoucher.rspTimeMi}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">实际到达时长(分钟)</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.arriveTimeMi == null ? '无' : servcWorkVoucher.arriveTimeMi}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">实际完成时长(分钟)</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.repairedTimeMi == null ? '无' : servcWorkVoucher.repairedTimeMi}}</span>
                </label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">实际回询时限(分钟)</div>
            <div class="content">
                <label class="mr20">
                    <span>{{servcWorkVoucher.rspTelCallTimeMi == null ? '无' : servcWorkVoucher.rspTelCallTimeMi}}</span>
                </label>
            </div>
        </div>
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>服务网点信息</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">服务商名称</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.servicerName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">服务网点名称</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.servicerShopName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">网点联系电话</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.servicerShopContractTel || '无'}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">网点联系人</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.servicerShopContractName || '无'}}</label>
            </div>
        </div>
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>工程师信息</span>
                <a class="swb-btn-link ml5" v-if="servcWorkVoucher.qualiClaimFlag" @click="showQualiClaim(servcWorkVoucher.id)">要求资质</a>
            </div>
        </div>
        <div class="form-single">
            <div class="title">主工程师</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.engineerName || '无'}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">辅助工程师</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.engineerNames || '无'}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">主工程师联系电话</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.contactTel || '无'}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">到达时间</div>
            <div class="content">
                <label class="mr20">{{servcWorkVoucher.toDoorTime || '无'}}</label>
            </div>
        </div>
        <div v-if="servcWorkVoucher.finished">
            <div class="content-caption bg-white dashed">
                <div class="fl">
                    <span>工单处理信息</span>
                </div>
            </div>
            <div class="form-single" v-if="servcWorkVoucher.reqVoucherId != null && servcWorkVoucher.reqVoucherId != -1">
                <div class="title">故障类型</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.faultTypeName || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">故障描述</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.faultDesc || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">维修类型</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.repairTypeName || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">服务完成时间</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.finishTime || '无'}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">处理结果</div>
                <div class="content">
                    <label class="mr20">{{servcWorkVoucher.handleResult || '无'}}</label>
                </div>
            </div>
        </div>
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>工单操作记录</span>
            </div>
        </div>
        <swb-servc-work-voucher-rec-list :voucherId="voucherId"></swb-servc-work-voucher-rec-list>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes, getComnMerchantBizTag} from '../../app.vues'
    import {openDevcInspectInfoDlg, openServcWorkStaffQualiDlg, showAsmblAccStockSetSelectDlg, openWorkVoucherPdfDlg} from './showDetailDlg';

    import servcDelivApi from '../../api/servcDeliv'

    // 订单收费项
    import SwbServcOrderChargeItemList from './ServcOrderChargeItemList';
    Vue.regist(SwbServcOrderChargeItemList);

    import SwbServcWorkVoucherRecList from './ServcWorkVoucherRecList';
    Vue.regist(SwbServcWorkVoucherRecList);

    //
    let bizTagObj = null;

    export default {
        name: 'swb-servc-work-voucher-detail',
        path: '',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '服务派工单详情',
        props: ['voucherId'],
        data: function () {
            return {
                servcWorkVoucher: {},
                workServcTypeMap: {},
                emgLevelMap: getEnumMap('emgLevel', 'value2text'),
                performFlagEnumMap: {}
            }
        },
        created: function () {
            bizTagObj = getComnMerchantBizTag();
            this.workServcTypeMap = getEnumMap('workServcType', 'value2text');
            this.performFlagEnumMap = getEnumMap('performFlag', 'value2text');
            if (!Utils.isNoB(this.voucherId)) {
                this.getServcWorkVoucher();
            }
        },
        methods: {
            isSJBH(devcXN){
                return !Utils.isNoB(devcXN) && devcXN.length == 26 && devcXN.indexOf("SJBH") == 0;
            },
            getServcWorkVoucher: function () {
                let self = this;
                let params = {};
                if (!Utils.isNoB(self.voucherId)) {
                    params.id = self.voucherId;
                }
                let theLoad = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherDetail(params, function (result) {
                    if (result.type === "info") {
                        let servcWorkVoucher = result.data;
                        if (!Utils.isNoB(servcWorkVoucher) && servcWorkVoucher.id > 0) {
                            //
                            let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                            if (servcWorkVoucher.closed) {
                                servcWorkVoucher.stateText = '已关闭';
                            } else if (servcWorkVoucher.invalid) {
                                servcWorkVoucher.stateText = '已作废';
                            } else if (stateInfo != null) {
                                servcWorkVoucher.stateText = stateInfo.text;
                            }
                            //
                            let engineerNameStr = servcWorkVoucher.engineerNames;
                            let engineerName = servcWorkVoucher.engineerName;
                            if (!Utils.isNoB(engineerNameStr)) {
                                let nameStr = null;
                                let engineerNames = engineerNameStr.split("、");
                                for (let i = 0; i < engineerNames.length; i++) {
                                    let name = engineerNames[i];
                                    if (name != engineerName) {
                                        if (nameStr == null) {
                                            nameStr = name;
                                        } else if (nameStr.indexOf(name) < 0) {
                                            nameStr = nameStr + '、' + name;
                                        }
                                    }
                                }
                                servcWorkVoucher.engineerNames = nameStr;
                            }
                            //
                            if (!Utils.isNoB(servcWorkVoucher.servicerTag)) {
                                let servicerTag = servcWorkVoucher.servicerTag;
                                let tagIdList = [];
                                if (!Utils.isNoB(servicerTag)) {
                                    if (servicerTag.indexOf("|") >= 0) {
                                        servcWorkVoucher.hasTag = true;
                                        servicerTag = servicerTag.substring(1, servicerTag.length - 1);
                                        tagIdList = servicerTag.split("|") || [];
                                    } else {
                                        servcWorkVoucher.hasTag = false;
                                    }
                                }
                                let tagNames = [];
                                for (let i = 0; i < tagIdList.length; i++) {
                                    let tagId = parseInt(tagIdList[i]);
                                    let tagName = bizTagObj.getBizTagNameById(tagId);
                                    if (tagName != null) {
                                        tagNames.push(tagName);
                                    }
                                }
                                servcWorkVoucher.tagNames = tagNames;
                            }
                        }
                        self.servcWorkVoucher = servcWorkVoucher;
                    } else {
                        MsgBox.warning(result.message);
                    }
                    theLoad.hide();
                });
            },
            // 查看收费项
            toChargeItems: function (workId, orderItemId) {
                Vue.$showDialog({
                    title: '工单 - 收费项',
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    width: 600,
                    height: 420,
                    template: '<div>' +
                    '<swb-servc-order-charge-item-list :workId="workId" :orderItemId="orderItemId" ref="swb_servc_order_charge_item_list"></swb-servc-order-charge-item-list>' +
                    '</div>',
                    data: {
                        workId: workId,
                        orderItemId: orderItemId
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            showImage(url){
                showImageViewBox(url);
            },
            //
            showDevcInspectInfo: function (workVoucherId) {
                //
                openDevcInspectInfoDlg(workVoucherId);
            },
            showQualiClaim(voucherId){
                openServcWorkStaffQualiDlg(voucherId);
            },
            showAsmblInfo(id){
                let params = {
                    shopDevcId: id
                };
                showAsmblAccStockSetSelectDlg(params);
            },
            // 打印PDF
            openWorkVoucherPdfDlg: function (voucherId) {
                //
                openWorkVoucherPdfDlg(voucherId);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherDetail.vue